import { render, staticRenderFns } from "./PharmacistsOverview.vue?vue&type=template&id=436819ea&scoped=true&"
import script from "./PharmacistsOverview.vue?vue&type=script&lang=js&"
export * from "./PharmacistsOverview.vue?vue&type=script&lang=js&"
import style0 from "./PharmacistsOverview.vue?vue&type=style&index=0&id=436819ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436819ea",
  null
  
)

export default component.exports